import { Item, Order, CustomerItemPreferencesMap, Transaction } from 'smartdishpro-scripts/ts_common';

export type TransHistory = {
  trans: Transaction;
  orders: Order[];
};

export type ItemHistory = {
  itemId: string;
  item: Item;
  quantity: number;
  latestOrderedAt: Date | null;
};

export const useHistory = (
  customerItemPreferencesMap?: CustomerItemPreferencesMap,
  items?: Item[]
): ItemHistory[] => {
  if (!customerItemPreferencesMap || !items) {
    return [];
  }

  // 一度のループで必要なアイテムを生成
  const itemHistories = Object.entries(customerItemPreferencesMap).reduce<ItemHistory[]>(
    (acc, [itemId, preferences]) => {
      const item = items.find((item) => item.id === itemId);
      if (!item) return acc;

      acc.push({
        itemId,
        item,
        quantity: preferences.quantity ?? 0,
        latestOrderedAt: preferences.latestOrderedAt ?? null,
      });
      return acc;
    },
    []
  );

  // ソート関数の定義
  const compareHistory = (a: ItemHistory, b: ItemHistory): number => {
    // 第1ソート: quantity（降順）
    if (b.quantity !== a.quantity) {
      return b.quantity - a.quantity;
    }

    // 第2ソート: latestOrderedAt（降順、nullは後ろに）
    if (!a.latestOrderedAt || !b.latestOrderedAt) {
      return !a.latestOrderedAt ? 1 : !b.latestOrderedAt ? -1 : 0;
    }

    // 両方Dateの場合のみ日付比較
    if (a.latestOrderedAt instanceof Date && b.latestOrderedAt instanceof Date) {
      return b.latestOrderedAt.getTime() - a.latestOrderedAt.getTime();
    }

    return 0;
  };

  // 重複を除去してソート
  return itemHistories
    .filter((x, i, arr) => arr.findIndex((y) => y.itemId === x.itemId) === i)
    .sort(compareHistory);
};
